import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import Seo from "../components/Seo";
import BookNowButton from "../components/BookNowButton";
import { HOTEL, ROOMS, HERO_IMAGE, formatPrice } from "../data/site";

export default function Home() {
  const previewRooms = [ROOMS[3], ROOMS[1], ROOMS[4]];
  return (
    <main>
      <Seo
        title="Hotel Gill Tower — Hotel in Hanumangarh, Rajasthan"
        description="Hotel Gill Tower in Sindhi Colony, Hanumangarh, Rajasthan offers single, double, twin and family rooms. View photos and book directly on WhatsApp."
      />
      <section className="hero">
        <div className="container hero-grid">
          <div className="hero-copy">
            <p className="eyebrow">Hotel · Hanumangarh, Rajasthan</p>
            <h1>Hotel Gill Tower</h1>
            <p className="address-line">
              <MapPin size={18} aria-hidden="true" />
              <span>{HOTEL.fullAddress}</span>
            </p>
            <p className="intro">
              Hotel Gill Tower offers simple, comfortable rooms in Hanumangarh,
              Rajasthan — from budget single rooms to spacious family rooms.
              Book your stay directly with us on WhatsApp.
            </p>
            <div className="hero-actions">
              <BookNowButton testId="book-now-hero" className="btn-large" />
              <Link
                to="/rooms"
                className="btn-outline"
                data-testid="home-view-rooms-link"
              >
                View Rooms
              </Link>
            </div>
          </div>
          <div className="hero-media">
            <img
              src={HERO_IMAGE}
              alt="Double room with air conditioning and television at Hotel Gill Tower, Hanumangarh"
            />
          </div>
        </div>
      </section>

      <section className="section section-alt">
        <div className="container">
          <div className="section-head">
            <h2>Our Rooms</h2>
            <p>
              Single, double, twin and family rooms for every budget — see all
              rooms and rates on the Rooms page.
            </p>
          </div>
          <div className="card-grid">
            {previewRooms.map((room) => (
              <article className="room-card" key={room.id}>
                <img
                  className="photo"
                  src={room.image}
                  alt={room.alt}
                  loading="lazy"
                />
                <div className="room-card-body">
                  <h3>{room.name}</h3>
                  <p className="price">
                    {formatPrice(room.price)} <small>/ night</small>
                  </p>
                  <Link
                    to="/rooms"
                    className="card-link"
                    data-testid={`home-room-card-link-${room.id}`}
                  >
                    View details
                  </Link>
                </div>
              </article>
            ))}
          </div>
          <div className="center-cta">
            <Link
              to="/rooms"
              className="btn-outline"
              data-testid="home-view-all-rooms"
            >
              View All Rooms &amp; Rates
            </Link>
          </div>
        </div>
      </section>

      <section className="cta-band">
        <div className="container">
          <h2>Ready to book your stay?</h2>
          <p>Message us on WhatsApp to check availability and book your room.</p>
          <BookNowButton testId="book-now-home-cta" className="btn-large" />
        </div>
      </section>
    </main>
  );
}
